export default "__VITE_ASSET__CxiqPAbp__"